/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../../constants';
const elementName = `${COMPONENT_NAME_PREFIX}mini-drawer`;
const attributes = {
    HOVER: 'hover'
};
export const MINI_DRAWER_CONSTANTS = {
    elementName,
    attributes
};
